module.exports = __webpack_public_path__ + "img/cases04.417a9fd8.png";